import { createContext, useContext, type ReactNode } from 'react'

const PricingPeriodEditorContext = createContext<{ periodId: string } | null>(null)

export function PricingPeriodEditorProvider({
    periodId,
    children,
}: {
    periodId: string
    children: ReactNode
}) {
    return (
        <PricingPeriodEditorContext.Provider value={{ periodId }}>
            {children}
        </PricingPeriodEditorContext.Provider>
    )
}

export function usePricingPeriodEditor() {
    const context = useContext(PricingPeriodEditorContext)
    if (!context) {
        throw new Error('usePricingPeriodEditor must be used within a PricingPeriodEditorProvider')
    }
    return context
}

export function usePricingPeriodEditorOptional() {
    return useContext(PricingPeriodEditorContext)
}
